import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

export default class BlindsFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.Across,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.Across;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.BLINDS;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof BlindsFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        this.direction === PresetSubtype.Across
            ?  this.applyHorizon(canvas) : this.applyVertical(canvas);
    }

    /**
     * 水平百叶窗效果
     * @param canvas
     */
    protected applyHorizon(canvas: Canvas) {
        const cvsHeight = canvas.height;
        const averageHeight = cvsHeight / 6;
        const sliceHeight = this.rate * averageHeight;
        const isEntr = this.action === Action.ENTR ;
        const { x } = canvas.bounds;
        const height = isEntr ?  averageHeight - sliceHeight : sliceHeight;
        for (let i = 0; i < 6; i++) {
            const y = isEntr ? (averageHeight * i) + sliceHeight : (averageHeight * (i + 1)) - sliceHeight ;
            canvas.clearRect(x, y + canvas.bounds.y, canvas.width, height);
        }
    }

    /**
     * 垂直百叶窗效果
     * @param canvas
     */
    protected applyVertical(canvas: Canvas) {
        const cvsWidth = canvas.width;
        const averageWidth = cvsWidth / 6;
        const sliceWidth = this.rate * averageWidth;
        const isEntr = this.action === Action.ENTR ;
        const { y } = canvas.bounds;
        const width = isEntr ?   averageWidth - sliceWidth : sliceWidth;
        for (let i = 0; i < 6; i++) {
            const x = isEntr ? (averageWidth * i) + sliceWidth : (averageWidth * (i + 1)) - sliceWidth ;
            canvas.clearRect(x + canvas.bounds.x, y, width, canvas.height);
        }
    }
}
